import React, { Component } from 'react';
// import InfiniteScroll from 'react-infinite-scroll-component';
import PropTypes from 'prop-types';
import { Close, Search2 } from '../toolset/assets/icons';
import { black } from '../../../../../styling/theme';
import wiseRefController from '../../../../../utility/wiseRefController';
import { LoadingIcon } from '../../../../common/alerts/loading';
import getToken from '../../../../../utility/getToken';
import journalTypes from '../../../../../constants/templateDictionaries/journalTypes';
import KEY_CODES from '../constants/keyCodes';
import {
  Container,
  InputContainer,
  HeadingContainer,
  Smart,
  CloseOuter,
  Input,
  ErrorMessage,
  AdvanceContainer,
  AdvancedButton,
  Button,
  ContentWrapper,
  InnerButton,
} from '../UI/referenceStyles/basicWrapper';
import SnackBarAlerts from '../../../../common/snackBarAlerts/snackBarAlerts';

import Logger from '../../../../../utility/services/Logger';

export default class BasicQuery2 extends Component {
  state = {
    results: null,
    waitingForReponse: false,
    searchQuery: '',
    wrongQuery: false,
    index: 0,
    showSnackBar: false,
  };

  crossrefAPICall = async () => {
    const { searchQuery } = this.state;
    if (!searchQuery.trim()) {
      this.setState({ wrongQuery: true });
      return;
    }

    this.setState({ waitingForReponse: true, wrongQuery: false });
    try {
      const token = await getToken();
      const respondJSON = await wiseRefController.referenceType(
        {
          query: `${searchQuery.trim().split(' ').join('+')}`,
          offset: 0,
          row: 20,
          style: journalTypes.APA.refStyle,
          locale: journalTypes.APA.refLocale,
          isPDF: true,
        },
        token,
      );

      this.setState({ results: respondJSON.data, index: 0 });
    } catch (err) {
      Logger.LogError(err);
      this.setState({ showSnackBar: true });
    }
    this.setState({ waitingForReponse: false });
  };

  fetchCitations = async () => {
    const { searchQuery, index, results } = this.state;
    if (!searchQuery.trim()) {
      this.setState({ wrongQuery: true });
      return;
    }
    try {
      const token = await getToken();
      const respondJSON = await wiseRefController.referenceType(
        {
          query: `${searchQuery.trim().split(' ').join('+')}`,
          offset: index + 20,
          row: 20,
          style: journalTypes.APA.refStyle,
          locale: journalTypes.APA.refLocale,
          isPDF: true,
        },
        token,
      );

      this.setState({
        results: results.concat(respondJSON.data),
        index: index + 20,
      });
    } catch (err) {
      Logger.LogError(err);
      this.setState({ showSnackBar: true });
    }
  };

  handleClick = (el) => {
    const { handleUpdateReference, closeModal } = this.props;
    handleUpdateReference(el);
    closeModal();
  };

  keyDown = (event) => {
    event.stopPropagation();
    if (event.which === KEY_CODES.ENTER) {
      this.crossrefAPICall(event);
    }
  };

  handleCloseSnackBar = () => {
    this.setState({ showSnackBar: false });
  };

  render() {
    const {
      waitingForReponse,
      searchQuery,
      results,
      wrongQuery,
      showSnackBar,
    } = this.state;
    const { switchMode, closeModal } = this.props;

    return (
      <Container>
        <SnackBarAlerts
          showSnackBar={showSnackBar}
          handleClose={this.handleCloseSnackBar}
          snackBarMessage="Provide Valid Information"
          snackBarType="error"
        />
        <HeadingContainer>
          <Smart>SMART</Smart>
          <CloseOuter data-testid="close" onClick={closeModal}>
            <Close fill={black} height="18px" width="18px" />
          </CloseOuter>
        </HeadingContainer>
        <InputContainer onKeyDown={this.keyDown}>
          <Input
            onChange={(event) => {
              event.preventDefault();
              this.setState({ searchQuery: event.target.value });
            }}
            value={searchQuery}
            type="text"
            placeholder="Search titles, authors, doi, isbn, ... etc!"
            data-testid="input"
          />
          {wrongQuery && (
            <ErrorMessage noResults={false}>
              Enter at least one search keyword!
            </ErrorMessage>
          )}
          <Button>
            <InnerButton
              onClick={!waitingForReponse ? this.crossrefAPICall : () => {}}
              data-testid="search"
            >
              {waitingForReponse ? (
                <LoadingIcon />
              ) : (
                <Search2 height="24" width="24" />
              )}
            </InnerButton>
          </Button>
        </InputContainer>
        <AdvanceContainer>
          <AdvancedButton onClick={() => switchMode('advanced')}>
            Advanced
          </AdvancedButton>
        </AdvanceContainer>
        {results &&
          Object.prototype.toString.call(results) !== '[object Object]' && (
            <ContentWrapper>
              {/* <InfiniteScroll
                dataLength={results.length}
                next={this.fetchCitations}
                hasMore
                loader={results.length > 5 && fetchResponse && <LoadingIcon />}
                height={results.length > 5 && '406px'}
              >
                {results.map((el) => (
                  <TextContainer
                    key={el}
                    value={el}
                    onClick={() => this.handleClick(el)}
                    data-testid="list"
                  >
                    <Text>{el}</Text>
                    <Check />
                  </TextContainer>
                ))}

                {results.length === 0 && (
                  <ErrorMessage noResults>No Results!</ErrorMessage>
                )}
              </InfiniteScroll> */}
            </ContentWrapper>
          )}
        {Object.prototype.toString.call(results) === '[object Object]' && (
          <ErrorMessage noResults>No Results!</ErrorMessage>
        )}
      </Container>
    );
  }
}

BasicQuery2.propTypes = {
  switchMode: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleUpdateReference: PropTypes.func.isRequired,
};
